import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Grid, makeStyles, Typography, Box } from "@material-ui/core";

import { getData } from "../../../../../services";
import { COLORS } from "../../../../../theme/colors";
import { Icon } from "../../../../../components/base";
import { ShaDowBox } from "../../../../../components/boxes";
import { ByArea, NoDataCard } from "../../../../../components/parts";
import roomImg from "../../../../../assets/images/icons/workspace/room.svg";
import includedImg from "../../../../../assets/images/icons/workspace/included.svg";
import usdImg from "../../../../../assets/images/icons/workspace/usd.svg";
import euroImg from "../../../../../assets/images/icons/workspace/euro.svg";
import onePersonImg from "../../../../../assets/images/icons/workspace/one-person.svg";
import twoPersonImg from "../../../../../assets/images/icons/workspace/two-person.svg";

const useStyles = makeStyles(() => ({
  grid: {
    height: 100,
  },
  text: {
    color: COLORS.davisGrey,
  },
}));

export const PriceModel = ({ id }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);
  const [status, setStatus] = useState();
  const [unitMeter, setUnitMeter] = useState();

  useEffect(() => {
    getData(`/praas/v2/buildings/${id}/properties/pricing-model/`, (data) => {
      setStatus(data.pricing_model);
      setUnitMeter(data.unit_meter_ownership_tenant);
    });

    return () => {
      setStatus();
      setUnitMeter();
    };
  }, [id]);

  const currencySelection = (value) => {
    switch (value) {
      case "usd":
      case "USD":
        return <Icon src={usdImg} />;
      case "eur":
      case "EUR":
        return <Icon src={euroImg} />;
      default:
        return <Icon src={includedImg} />;
    }
  };

  const action = {
    FIX_PRICE: {
      content: <Icon src={onePersonImg} style={{ height: 100, width: 75 }} />,
      text: "Fix price per tenant",
    },
    PERCENT_SPACE: {
      content: (
        <Typography style={{ fontSize: 32, lineHeight: "38px" }} className={classes.text}>
          %
        </Typography>
      ),
      text: "% of rental",
    },
    BY_AREA: {
      content: <ByArea xStyle={{ fontSize: 18 }} textStyle={{ fontSize: 18 }} />,
      text: `Based on ${user?.unit_system}`,
    },
    NUMBER_TENANTS: {
      content: <Icon src={twoPersonImg} style={{ height: 100 }} />,
      text: "Based on number of tenants",
    },
    NUMBER_ROOMS: {
      content: <Icon src={roomImg} style={{ height: 100 }} />,
      text: "Based on number of rooms",
    },
    NOTHING: {
      content: currencySelection(user.currency),
      text: "Nothing. Electricity included in rental",
    },
    UNKNOWN: {
      content: (
        <Typography style={{ fontSize: 36, lineHeight: "42px" }} className={classes.text}>
          ?
        </Typography>
      ),
      text: "Not specified",
    },
    NULL: {
      content: currencySelection(user.currency),
      text: "None, Tenant pays directly",
    },
  };

  if (!status && !unitMeter) {
    return <NoDataCard title="Pricing Model" />;
  }

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4">Pricing Model</Typography>
        <Box style={{ textAlign: "center", marginTop: 54 }}>
          <Grid container justifyContent="center" alignItems="center" className={classes.grid}>
            {unitMeter ? action.NULL.content : action[status]?.content }
          </Grid>
          <Typography variant="h3" style={{ marginTop: 42 }}>
            {unitMeter ? action.NULL.text : action[status]?.text}
          </Typography>
        </Box>
      </Box>
    </ShaDowBox>
  );
};
